import { useTheme } from "@/hooks/useTheme";
import { StatusConfig } from "./types";

export const useStatusConfig = () => {
  const { colors } = useTheme();

  const statusConfig: Record<"accepted" | "declined" | "pending", StatusConfig> = {
    accepted: {
      color: colors.emerald.border,
      icon: "check-circle" as const,
      gradient: [colors.emerald.border, colors.emerald.background],
    },
    declined: {
      color: colors.rose.border,
      icon: "close-circle" as const,
      gradient: [colors.rose.border, colors.rose.background],
    },
    pending: {
      color: colors.amber.border,
      icon: "clock-outline" as const,
      gradient: [colors.amber.border, colors.amber.background],
    },
  };

  return statusConfig;
};
